import { Button } from '@cad-arc';
import { useWatch } from 'react-hook-form';
import { ResponsiveButtons } from '../../common/components/responsive-buttons';
import { FormSaveButton } from '../../forms/integrated-form-components/form-save-button';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { DexFormModel, DexInquiry } from '../types';
import { isParamsValid } from '../utils';
import {
    dexClearFormButtonBreakpoint,
    dexSendAndClearFormButtonBreakpoint,
    dexSendButtonBreakpoint,
} from '../../common/constants';

export function DexFormFooter({
    defaultParams,
    clearForm,
    sendAndClearForm,
}: {
    defaultParams: DexInquiry;
    clearForm: () => void;
    sendAndClearForm: () => void;
}): React.ReactElement {
    const integratedForm = useIntegratedForm<DexFormModel<DexInquiry>>();
    const params = useWatch({ name: 'params', control: integratedForm.form.control });
    const isValid = isParamsValid(params, defaultParams);
    return (
        <ResponsiveButtons
            containerProps={{
                justifyContent: 'flex-end',
                padding: '16px 24px',
                borderTop: 'var(--arc-borders-sm)',
                borderTopColor: 'var(--arc-colors-border-default)',
            }}
            buttons={[
                {
                    breakpoint: dexClearFormButtonBreakpoint,
                    component: (
                        <Button variant="outline" onClick={clearForm} key="clear-button">
                            Clear Form
                        </Button>
                    ),
                },
                {
                    breakpoint: dexSendButtonBreakpoint,
                    component: (
                        <FormSaveButton key="save-button" isDisabled={!isValid}>
                            Send
                        </FormSaveButton>
                    ),
                },
                {
                    breakpoint: dexSendAndClearFormButtonBreakpoint,
                    component: (
                        <FormSaveButton
                            key="save-and-clear-form-button"
                            isDisabled={!isValid}
                            onClick={sendAndClearForm}
                        >
                            Send & Clear Form
                        </FormSaveButton>
                    ),
                },
            ]}
        />
    );
}
